import queryString from 'query-string';
import { Component } from 'react';
import { withRouter } from 'react-router-dom';

import Account from './account/Account';
import CustomerLoggedInPickup from './customer/CustomerLoggedInPickup';
import CustomerLoggedInShip from './customer/CustomerLoggedInShip';
import CustomerNotLoggedInPickup from './customer/CustomerNotLoggedInPickup';
import CustomerNotLoggedInShip from './customer/CustomerNotLoggedInShip';
import PaymentLoggedInPickup from './payment/PaymentLoggedInPickup';
import PaymentLoggedInShip from './payment/PaymentLoggedInShip';
import PaymentNotLoggedInPickup from './payment/PaymentNotLoggedInPickup';
import PaymentNotLoggedInShip from './payment/PaymentNotLoggedInShip';
import Process from './process/Process';

class EditStep extends Component {
  constructor(props) {
    super(props);
    const { clubSignup } = props;
    let orderDeliveryMethod = 'Ship';
    const { deliveryMethod } = queryString.parse(props.location.search);
    if (deliveryMethod === 'Pickup') {
      orderDeliveryMethod = 'Pickup';
    }
    props.location.search = '';
    if (clubSignup && clubSignup.orderDeliveryMethod) {
      orderDeliveryMethod = clubSignup.orderDeliveryMethod;
    }
    this.state = { orderDeliveryMethod };
  }

  handlePickup = () => {
    this.setState({ orderDeliveryMethod: 'Pickup' });
  };

  handleShip = () => {
    this.setState({ orderDeliveryMethod: 'Ship' });
  };

  render() {
    const { step, onEdit, clubSignup, customer, club } = this.props;
    const { orderDeliveryMethod } = this.state;
    switch (step) {
      case 'customer':
        if (orderDeliveryMethod === 'Ship') {
          if (customer && clubSignup.customerId) {
            return (
              <CustomerLoggedInShip
                onEdit={onEdit}
                onPickup={this.handlePickup}
              />
            );
          }
          return (
            <CustomerNotLoggedInShip
              onEdit={onEdit}
              onPickup={this.handlePickup}
            />
          );
        }
        if (customer && clubSignup.customerId) {
          return (
            <CustomerLoggedInPickup onEdit={onEdit} onShip={this.handleShip} />
          );
        }
        return (
          <CustomerNotLoggedInPickup onEdit={onEdit} onShip={this.handleShip} />
        );
      case 'payment':
        if (orderDeliveryMethod === 'Ship') {
          if (customer && clubSignup.customerId) {
            return (
              <PaymentLoggedInShip
                clubSignup={clubSignup}
                club={club}
                onEdit={onEdit}
              />
            );
          }
          return <PaymentNotLoggedInShip onEdit={onEdit} club={club} />;
        }
        if (customer && clubSignup.customerId) {
          return (
            <PaymentLoggedInPickup
              clubSignup={clubSignup}
              club={club}
              onEdit={onEdit}
            />
          );
        }
        return <PaymentNotLoggedInPickup onEdit={onEdit} club={club} />;
      case 'account':
        return <Account onEdit={onEdit} club={club} />;
      case 'complete':
        return <Process club={club} />;
      default:
        throw new Error('Invalid Step');
    }
  }
}

export default withRouter(EditStep);
